export const GA_MEASUREMENT_ID =
  import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-3H6ZZ6PYZC'

export const GA_SCRIPT_URL = 'https://www.googletagmanager.com/gtag/js'

/** GA loads on the live storefront and any domains configured in VITE_GA_PRODUCTION_HOSTS. */
const customHosts = import.meta.env.VITE_GA_PRODUCTION_HOSTS
  ? import.meta.env.VITE_GA_PRODUCTION_HOSTS.split(',').map((h: string) => h.trim())
  : []

export const GA_PRODUCTION_HOSTS: readonly string[] = [
  'maaliondoor.in',
  'www.maaliondoor.in',
  'maaliondoor-frontend-prod-989790503316.europe-west1.run.app',
  ...customHosts,
]

